import { QRCode } from 'react-qr-svg';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import queryString from 'query-string';

import { BarButton } from '../../components/Button';
import { FloatingModal } from '../../components/Modal';
import { getMyAchievements } from '../../../../ducks/achievements';
import { getTickets } from '../../../../ducks/user/user';
import { navigatePush } from '../../../../helpers';
import AnimatedRoutes from '../../components/AnimatedRoutes';
import Connections from '../Settings/Connections';
import Content from '../../components/Content';
import Data from '../Settings/Data';
import Dev from '../Settings/Dev';
import Header from '../../components/Header';
import Security from '../Settings/Security';
import Subheader from '../../components/Subheader';
import Tickets from '../Tickets';
import UserImage from '../../../Crew/components/UserImage';
import Verify from '../Settings/Verify';
import requireUser from '../../../../components/requireUser';
import styles from './profile.scss';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
    goBack: PropTypes.func.isRequired,
    stackPush: PropTypes.func.isRequired,
    stackPop: PropTypes.func.isRequired,
  }),
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
  }),
  onLogout: PropTypes.func.isRequired,
  userAchievements: ImmutablePropTypes.list,
  loading: PropTypes.bool,
  showOffers: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  offers: PropTypes.shape(),
  seenOffers: PropTypes.shape(),
  match: PropTypes.shape({
    url: PropTypes.string,
    path: PropTypes.string,
  }),
};

class Profile extends React.Component {
  constructor(props) {
    super(props);
    const parsed = queryString.parse(props.history.location.search);
    this.state = {
      codeModalOpen: parsed.id === 'true' || false,
      unlockDev: 0,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getMyAchievements());
    dispatch(getTickets());
  }

  openCodeModal = () => {
    this.setState({
      codeModalOpen: true,
    });
  }

  closeCodeModal = () => {
    this.setState({
      codeModalOpen: false,
    });
  }

  onUnlockDev = () => {
    if (this.timeoutUnlockDev) {
      this.setState((state) => {
        if (state.unlockDev === 2) {
          clearTimeout(this.timeoutUnlockDev);
          this.timeoutUnlockDev = null;
          navigatePush(this.props.history, 'dev');
          return { unlockDev: 0 };
        }

        return { unlockDev: state.unlockDev + 1 };
      });
    } else {
      this.timeoutUnlockDev = setTimeout(() => {
        this.setState({
          unlockDev: 0,
        });
        this.timeoutUnlockDev = null;
      }, 1000);
    }
  }

  render() {
    const {
      user,
      history,
      onLogout,
      location,
      match,
    } = this.props;
    const { codeModalOpen } = this.state;

    const relativeUrl = (match && match.url) || '';

    return (
      <>
        <Header
          right={(
            <div
              className={styles.done}
              role="button"
              tabIndex={0}
              onClick={() => history.stackPop()}
            >
              Done
            </div>
          )}
        />
        <Content>
          <div className={styles.hero}>
            <div
              className={styles.code}
              role="button"
              tabIndex={0}
              onClick={() => this.openCodeModal()}
            >
              <div className={styles.canvasContainer}>
                <UserImage
                  id={user.id}
                  size={106}
                  clickable={false}
                />
              </div>
            </div>
            <div
              className={styles.info}
              onClick={this.onUnlockDev}
              role="button"
              tabIndex="-1"
            >
              <div className={styles.username}>
                {user.name}
              </div>
              <div className={styles.name}>
                {user.first_name}
                {' '}
                {user.last_name}
              </div>
            </div>
          </div>
          <div className={styles.settings}>
            <BarButton
              icon="ticket-alt"
              onClick={() => navigatePush(history, 'tickets')}
              arrow
              background="#575fcf"
            >
              My tickets
            </BarButton>

            <Subheader>
              My account
            </Subheader>
            <BarButton
              icon="cog"
              onClick={() => window.open('https://dreamhack.com/download')}
              external
              background="#ffa801"
            >
              Profile settings
            </BarButton>
            <BarButton
              icon="link"
              onClick={() => navigatePush(history, 'connections')}
              arrow
              background="#f53b57"
            >
              Linked accounts
            </BarButton>

            <Subheader borderTop>
              Data & Privacy
            </Subheader>
            <BarButton
              icon="scroll"
              onClick={() => window.open('https://dreamhack.com/privacy')}
              external
              background="#607D8B"
            >
              Privacy notice
            </BarButton>
            <BarButton
              icon="scroll"
              onClick={() => window.open('https://dreamhack.com/policy')}
              external
              background="#607D8B"
            >
              Terms of service
            </BarButton>
            <BarButton
              icon="shield-alt"
              onClick={() => navigatePush(history, 'security')}
              arrow
              background="#607D8B"
            >
              Account security
            </BarButton>
            <BarButton
              icon="database"
              onClick={() => navigatePush(history, 'data')}
              arrow
              background="#607D8B"
            >
              Manage personal data
            </BarButton>
            <Subheader borderTop />
            <BarButton
              icon="sign-out"
              onClick={onLogout}
              background="#9E9E9E"
            >
              Sign out
            </BarButton>
            <Subheader borderTop />
          </div>
          <FloatingModal
            isOpen={codeModalOpen}
            onRequestClose={() => this.closeCodeModal()}
            buttonText="Close"
          >
            <div className={styles.bigCode}>
              <QRCode
                bgColor="#ffffff"
                fgColor="#1e1e20"
                level="L"
                style={{ width: '100%', maxWidth: '240px' }}
                value={user.id}
              />
              <div className={styles.textCode}>
                {user.id}
              </div>
            </div>
          </FloatingModal>
        </Content>
        <AnimatedRoutes location={location}>
          <Route exact path={`${relativeUrl}/tickets`} render={(props) => (<Tickets {...props} />)} />
          <Route exact path={`${relativeUrl}/data`} render={(props) => (<Data {...props} />)} />
          <Route exact path={`${relativeUrl}/security`} render={(props) => (<Security {...props} />)} />
          <Route exact path={`${relativeUrl}/data/verify/:requestId`} render={(props) => (<Verify {...props} />)} />
          <Route exact path={`${relativeUrl}/connections`} render={(props) => (<Connections {...props} />)} />
          <Route exact path={`${relativeUrl}/dev`} render={(props) => (<Dev {...props} />)} />
        </AnimatedRoutes>
      </>
    );
  }
}


function mapStateToProps(state) {
  return {
    userAchievements: state.getIn(['achievements', 'userAchievements']),
    loading: state.getIn(['achievements', 'loadingMe']),
    error: state.getIn(['achievements', 'errorMe']),
  };
}
Profile.propTypes = propTypes;

export default requireUser(connect(mapStateToProps)(Profile));
